import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconLocationPin = props => {
  if (props.id !== "_svgiconlocationpin") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><path d="M24 10c5.523 0 10 4.446 10 10.887C34 27.33 24 38 24 38S14 27.338 14 20.917C14 14.495 18.477 10 24 10zm0 15.63c3.022 0 5.48-2.512 5.48-5.6 0-3.087-2.458-5.598-5.48-5.598-3.022 0-5.48 2.511-5.48 5.598 0 3.088 2.458 5.6 5.48 5.6z" fill="#384048" fillRule="evenodd" /></svg>;
};

SvgIconLocationPin.displayName = "_svgiconlocationpin";
SvgIconLocationPin.propTypes = {
  id: PropTypes.string
};
SvgIconLocationPin.defaultProps = {
  id: ''
};
export default SvgIconLocationPin;